import ja from 'vuetify/lib/locale/ja'
import global_config from '@/../config.json'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 閉じる
export default {
  ...ja,
  __General: {
    submit: '送信'
  },
  __InitialLoading: {
    connecting: '接続中...'
  },
  __ChatBubbleAi: {
    default_answer_by: global_config.default_answer_by_ja || 'AIが生成した答え',
    default_answer_desc: global_config.default_answer_desc_ja || 'AIが生成した答え',
    answer_by_mrc: 'MRCによる回答',
    mrc_answer_desc: 'MRC（機械読解）はテキストドキュメントをスキャンし、テキストから意味を抽出します',
    answer_by_chatGPT: 'ChatGPTによる回答',
    chatgpt_answer_desc: 'ChatGPTは、OpenAIによって開発されたAIチャットボットで、自然言語処理を使用して人間のような会話を作成します。',
    prompt_bar_message: 'このコンテンツは役に立ちましたか？',
    comment_dialog: {
      title: '評価の理由を共有していただけますか？',
      yes: 'はい',
      no: 'いいえ',
      placeholder: 'ここにコメントを書いてください',
      remaining_character: '残りの文字数: {0}/{1}',
      submit: '送信',
      closing: 'コメントありがとうございます！'
    }
  },
  __InputBar: {
    placeholder: 'ここに入力してください（個人情報は入力しないでください！）',
    press_to_record: '長押しして録音',
    press_once_to_record: 'タップして録音',
    recording_press_once_to_stop: '録音中...（タップして停止）',
    recording: '録音中...',
    upload_file: 'ファイルをアップロード',
    upload_file_error: 'ファイルのアップロードに失敗しました。もう一度お試しください。',
    upload_file_success: 'ファイルのアップロードに成功しました',
    file_size_limit: 'ファイルサイズは10MBを超えることはできません',
    file_type_not_supported: 'このファイルタイプはサポートされていません'
  }
}
